module.exports = __webpack_public_path__ + "static/0012-f215a4c643fae490ee1812a10917fb28.png";